import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import {
  BrowserModule,
  provideClientHydration,
} from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ToastInterceptor } from "./_interceptors/request-interceptor";
import { GlobalErrorHandlerService } from "./_interceptors/error-interceptor";
import { ToastComponent } from "./_components/toast/toast.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateFormats } from "./_shared/material/material-form.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AuthenticationStoreService } from "./stores/staybloom/authenticationStore/authenticationStore.services";
export function initAuth(authService: AuthenticationStoreService) {
  return () => authService.loadUserAuthenticatedAccess();
}

@NgModule({
  declarations: [AppComponent, ToastComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatSelectModule,
    MatTooltipModule,
    HttpClientModule,
  ],
  providers: [
    provideClientHydration(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ToastInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    { provide: MAT_DATE_FORMATS, useValue: DateFormats },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_LOCALE, useValue: "en-IN" },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthenticationStoreService],
      multi: true,
    },
  ],
})
export class AppModule {}
